/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_invite_page_footer_text = /** @type {(inputs: {}) => string} */ () => {
	return `Al aceptar, podrás gestionar tu contratación de forma rápida, segura y 100% en línea, revisa nuestros`
};

const en_invite_page_footer_text = /** @type {(inputs: {}) => string} */ () => {
	return `By accepting, you'll be able to manage your hiring quickly, securely, and 100% online, review our`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const invite_page_footer_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_page_footer_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_page_footer_text", locale)
	if (locale === "es") return es_invite_page_footer_text(inputs)
	return en_invite_page_footer_text(inputs)
};
export { invite_page_footer_text as "invite.page.footer_text" }